import {
  CalendarOutlined,
  CameraOutlined,
  HomeOutlined,
  ScissorOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SoundOutlined,
  StarOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { Card, CheckboxRef, Form, Radio, Space, Typography } from 'antd'
import { Industry } from '../../models/Industry'
import { useRef } from 'react'
import { LegacyRef } from 'react'

const { Title, Text } = Typography

interface Props {
  industry: Industry
}
const IndustryCard = ({ industry }: Props) => {
  const icons = {
    CalendarOutlined,
    CameraOutlined,
    HomeOutlined,
    ScissorOutlined,
    ShopOutlined,
    ShoppingCartOutlined,
    SoundOutlined,
    StarOutlined,
    ThunderboltOutlined,
  } as const

  type IconKey = keyof typeof icons

  const formInstance = Form.useFormInstance()
  const industryWatch = Form.useWatch('industry')
  const test: LegacyRef<CheckboxRef> = useRef(null)

  const renderIcon = (iconName: string) => {
    const IconComponent = icons[iconName as IconKey]

    if (!IconComponent) {
      return <></>
    }

    return <IconComponent />
  }
  const color = industryWatch == industry.id ? '#a58aeb' : undefined
  return (
    <Card
      onClick={() => {
        formInstance.setFieldValue('industry', industry.id)
      }}
      className="w-full"
      style={{
        border: industryWatch == industry.id ? '1px solid #a58aeb' : undefined,
        cursor: 'pointer',
      }}
      styles={{
        body: {
          padding: 10,
          paddingLeft: 20,
          paddingRight: 15,
        },
      }}
    >
      <Space size={5} className="w-full">
        <Title className="m-0" level={3} style={{ color: color }}>
          {renderIcon(industry.icon)}
        </Title>
        <Radio
          ref={test}
          value={industry.id}
          style={{ display: 'none' }}
        ></Radio>
        <Space direction="vertical" size={0} className="w-full">
          <Title style={{ color: color }} className="m-0" level={5}>
            {industry.title}
          </Title>
          <Text style={{ color: color }} type="secondary">
            {industry.description}
          </Text>
        </Space>
      </Space>
    </Card>
  )
}

export default IndustryCard
